import { ChangeDetectionStrategy, Component, computed, OnDestroy, signal, Signal, WritableSignal } from '@angular/core';
import { PlycaUiTabsComponent } from '../tabs.component';
import { TabsDemoCatalog } from './_config/tabs-demo.const';

@Component({
  selector: 'plyca-ui-tabs-demo',
  templateUrl: './tabs-demo.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiTabsComponent]
})
export class PlycaUiTabsDemoComponent implements OnDestroy {
  public currentIndexSig: Signal<number> = computed(() => 0);
  public badgeContentData = computed(() => ({ 1: 5 }));
  public tabsSig = TabsDemoCatalog;
  public cacheTabSig: WritableSignal<boolean> = signal(false);

  constructor() {
    this._controlBadge();
  }

  private _controlBadge(): void {
    this.badgeContentData = computed(() => ({ 1: 5 }));
  }

  public onChangeIndex(event: number): void {
    this.currentIndexSig = computed(() => event);
  }

  ngOnDestroy(): void {
    this.cacheTabSig.set(false);
  }
}
